App.controller('ZochLifeInsuranceRelatedCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaLifeInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'insuranceService', 'zochaWorkersService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaLifeInsuranceService, $timeout, $stateParams, Blob, FileSaver, insuranceService, zochaWorkersService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Szczegóły deklaracji';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.lifeInsurance.list';
    $scope.$emit('link', $scope.link);

    $scope.declarationEntity = $stateParams.insurance || null;

    if(!$scope.declarationEntity){
        console.log('[ZochLifeInsuranceRelatedCtrl] no declaration entity', angular.copy($stateParams));
        $state.go('root.home.zoch.lifeInsurance.list', angular.extend($stateParams));
        return;
    }
    console.log('[ZochLifeInsuranceRelatedCtrl]', '$scope.declarationEntity', angular.copy($scope.declarationEntity));

    var userId = $scope.declarationEntity.declaration.userId;
    $scope.declarations = [];
    zochaLifeInsuranceService.dataList({
        userId: userId,
        pageSize: 1000000,
        pageNumber: 0,
        search: ''
    }).then(function (success) {
        console.log('[getDeclarations]', 'success', angular.copy(success));
        $scope.declarations = success.data.data;
    });

    $scope.getDeclaration = function(ev, declarationEntity) {
        if(ev){
            ev.preventDefault();
            ev.stopPropagation();
        }
        var declaration = declarationEntity.declaration, id = declaration.uuid,
            barcode = declaration.barcode;

        zochaLifeInsuranceService.getDeclaration(id).then(function (response) {
            var data = new Blob([response.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
        });
    };
}]);